const observerConfig = {
  root: null,
  threshold: 0,
  rootMargin: '0px 0px 0px 0px'
};

export function initTextVhs() {
  initMainHeroAnimation();

  const vhsRoots = document.querySelectorAll('.text-vhs');
  if (!vhsRoots.length) return;

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle('is-vhs-active', entry.isIntersecting);
    });
  }, observerConfig);

  vhsRoots.forEach((root) => {
    decorateVhsRoot(root);
    if (root.closest('.section_main-hero')) {
      initHeroScrollReveal(root);
    } else {
      visibilityObserver.observe(root);
    }

    const mutationObserver = new MutationObserver(() => {
      decorateVhsRoot(root);
    });

    mutationObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
}

function initMainHeroAnimation() {
  const hero = document.querySelector('.section_main-hero');
  const animationClip = document.querySelector('.animation-clip');

  if (!hero || !animationClip || typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);

  window.gsap.set(animationClip, {
    '-webkit-mask-size': '200%',
    'mask-size': '200%'
  });

  window.gsap.to(animationClip, {
    '-webkit-mask-size': '20rem',
    'mask-size': '20rem',
    ease: 'power2.out',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      markers: false
    }
  });
}

function initHeroScrollReveal(root) {
  const hero = root.closest('.section_main-hero');
  if (!hero) return;

  const revealProgress = 0.82;
  let rafId = null;
  let isVisible = false;
  let burstTimeoutId = null;

  root.classList.add('has-vhs-scroll-reveal');
  root.classList.remove('is-vhs-visible', 'is-vhs-active');

  const clearBurst = () => {
    if (burstTimeoutId !== null) {
      window.clearTimeout(burstTimeoutId);
      burstTimeoutId = null;
    }
  };

  const triggerBurst = (direction) => {
    clearBurst();
    root.classList.remove('is-vhs-burst-in', 'is-vhs-burst-out');
    root.classList.add(direction === 'in' ? 'is-vhs-burst-in' : 'is-vhs-burst-out');

    burstTimeoutId = window.setTimeout(() => {
      root.classList.remove('is-vhs-burst-in', 'is-vhs-burst-out');
      burstTimeoutId = null;
    }, 520);
  };

  const updateVisibility = () => {
    rafId = null;

    const rect = hero.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const travel = Math.max(rect.height - viewportHeight, 1);
    const progress = Math.min(Math.max(-rect.top / travel, 0), 1);
    const nextVisible = progress >= revealProgress && rect.bottom > 0;

    if (nextVisible === isVisible) return;

    isVisible = nextVisible;
    root.classList.toggle('is-vhs-visible', isVisible);
    root.classList.toggle('is-vhs-active', isVisible);
    triggerBurst(isVisible ? 'in' : 'out');
  };

  const requestUpdate = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(updateVisibility);
  };

  requestUpdate();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
}

function decorateVhsRoot(root) {
  clearExistingSegments(root);

  const targets = getSegmentTargets(root);
  const usesSegments = targets.length > 1 || targets[0] !== root;

  root.classList.toggle('has-vhs-segments', usesSegments);

  targets.forEach((target) => {
    const text = getTargetText(target);
    if (!text) return;

    target.classList.add('text-vhs__segment');
    target.setAttribute('data-text', text);
  });
}

function clearExistingSegments(root) {
  root.classList.remove('has-vhs-segments');

  root.querySelectorAll('.text-vhs__segment').forEach((segment) => {
    segment.classList.remove('text-vhs__segment');
    segment.removeAttribute('data-text');
  });

  root.removeAttribute('data-text');
}

function getSegmentTargets(root) {
  const directChildren = Array.from(root.children).filter((child) => child.textContent.trim());

  if (directChildren.length > 1) {
    return directChildren;
  }

  return [root];
}

function getTargetText(element) {
  return element.textContent.replace(/\s+/g, ' ').trim();
}
